<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">
        <ak-inputs ref="inputs" :options="options" v-model="data"/>
        <a-form-item>
          <a-button type="primary" @click="save">保存</a-button>
        </a-form-item>
      </a-col>
      <a-col :md="24" :lg="8" :style="{ minHeight: '180px' }">
        <ak-input-image disabled round class="ant-upload-preview" v-model="avatar" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import defaultAvatar from '@/assets/images/avatar.png'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      avatar: defaultAvatar,
      options: [{
        name: 'password',
        note: '原密码',
        type: 'String',
        tooltip: '请您输入原密码',
        password: true,
        validators: [
          (val) => val ? null : '原密码不可为空',
          (val) => {
            let reg = /^[0-9a-zA-Z]*$/g
            return reg.test(val) ? null : '原密码格式不正确'
          }
        ]
      }, {
        name: 'newPassword',
        note: '新的密码',
        type: 'String',
        tooltip: '请您输入新的密码',
        password: true,
        validators: [
          (val) => val ? null : '新的密码不可为空',
          (val) => {
            let reg = /^[0-9a-zA-Z]*$/g
            return reg.test(val) ? null : '新的密码格式不正确'
          }
        ]
      }, {
        name: 'againPassword',
        note: '新的密码',
        type: 'String',
        tooltip: '请您再次输入新的密码',
        password: true,
        validators: [
          (val) => val ? null : '新的密码不可为空',
          (val) => {
            let reg = /^[0-9a-zA-Z]*$/g
            return reg.test(val) ? null : '新的密码格式不正确'
          }
        ]
      }],
      data: {}
    }
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  mounted () {
    if (this.user.avatar) {
      this.avatar = this.user.avatar
    }
  },
  methods: {
    // 保存数据
    async save () {
      let inputsData = this.data
      let data = { ...inputsData }
      // 判断用户名密码是否存在
      let erros = await this.$refs.inputs.validate()
      if (Object.keys(erros).length) {
        return this.$notification['error']({
          message: '您的密码不存在',
          description: '修改密码失败'
        })
      }
      // 判断原密码是否正确
      await this.$tkParse.post('/login', {
        username: this.user.username,
        password: data.password
      }).catch(e => {
        throw this.$notification['error']({
          message: '原密码不正确',
          description: '修改密码失败'
        })
      })
      // 判断两次输入密码是否一致
      if (data.newPassword !== data.againPassword) {
        throw this.$notification['error']({
          message: '两次输入的密码不一致',
          description: '修改密码失败'
        })
      }
      // 判断新密码是否和原密码一致
      let status = await this.$tkParse.post('/login', {
        username: this.user.username,
        password: data.againPassword
      }).then(e => {
        return 'fail'
      }).catch(() => {
        return 'success'
      })
      if (status === 'fail') {
        throw this.$notification['error']({
          message: '新密码与原密码一致',
          description: '修改密码失败'
        })
      }
      this.$tkParse.put(`/classes/_User/${this.user.objectId}`, { password: data.againPassword }).catch((e) => {
        this.$notification['error']({
          message: '网络错误',
          description: '无法保存数据'
        })
        throw e
      })
      this.$notification['success']({
        message: '密码修改成功',
        description: '请您重新登录'
      })
      this.$tkParse.setSessionToken(null)
      this.$store.commit('setUser', null)
      this.$store.commit('setSessionToken', null)
      this.$router.replace('/user/login')
    }
  }
}
</script>

<style lang="scss" scoped>

  .avatar-upload-wrapper {
    height: 200px;
    width: 100%;
  }

  .ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    .mask {
      opacity: 0;
      position: absolute;
      cursor: pointer;
      transition: opacity 0.4s;

      &:hover {
        opacity: 1;
      }

      i {
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: #d6d6d6;
      }
    }

    img, .mask {
      width: 100%;
      max-width: 180px;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>
